// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetMarkedListRequest,
  TGetMarkedListModel,
  IMappers,
  TGetMarkedListResponse,
  IGetMarkedListResponse,
  IGetMarkedListResponseError,
} from './types';

export const defaultConfig: TGetMarkedListModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'countryside-search',
  pathApi: '/v1/get-marked-list/',
} as TGetMarkedListModel;

export function createGetMarkedListModel(parameters: IGetMarkedListRequest): TGetMarkedListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetMarkedListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetMarkedListRequest;
}

export async function fetchGetMarkedList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMarkedListOptions<TResponse200, TResponse400>): Promise<TGetMarkedListResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetMarkedListModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMarkedListResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetMarkedListResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetMarkedListResponse;
}
